import { render } from "./EventList.vue?vue&type=template&id=e40a57a0&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=e40a57a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e40a57a0"

export default script